import gql from 'graphql-tag';

export default ({ page, size, accountId, subscriptionId, startDate, endDate }) => {
  // Only add the date fields to the string if they contain a value
  const startDateFilter = startDate ? `, startDate: "${startDate}"` : '';
  const endDateFilter = endDate ? `, endDate: "${endDate}"` : '';

  return gql`
      query {
          searchSubscriptionTopUp(
              page: ${page},
              size: ${size},
              filter: {
                  accountId: "${accountId}",
                  subscriptionId: "${subscriptionId}"${startDateFilter}${endDateFilter}
              }
          ) {
              id
              createdDate
              amount
              paymentSource
          }
      }
  `;
};